export const enumBilleteraComisiones = Object.freeze({
  billetera_comisiones: 20000,
  movimiento_comisiones_cupo: 20001,
  tranferencia_billetera_usuario_padre: 20100,
  ver_historial_transferencia_billetera_up_soporte: 20101,
});
